// Patient Workflow Service - AI-powered reminders, alerts, and automation
import api from './api';

// ==================== FOLLOW-UP REMINDERS ====================

export const getFollowUpReminders = async (patientId) => {
  const response = await api.get(`/api/v1/patient-workflows/patient/${patientId}/follow-up-reminders`);
  return response.data;
};

export const createFollowUpReminder = async (patientId, reminderData) => {
  const response = await api.post(`/api/v1/patient-workflows/patient/${patientId}/follow-up-reminders`, reminderData);
  return response.data;
};

// ==================== MEDICATION REMINDERS ====================

export const getMedicationReminders = async (patientId) => {
  const response = await api.get(`/api/v1/patient-workflows/patient/${patientId}/medication-reminders`);
  return response.data;
};

export const logMedicationAdherence = async (patientId, logData) => {
  const response = await api.post(`/api/v1/patient-workflows/patient/${patientId}/medication-adherence`, logData);
  return response.data;
};

// ==================== CARE ALERTS ====================

export const getCareAlerts = async (patientId) => {
  const response = await api.get(`/api/v1/patient-workflows/patient/${patientId}/care-alerts`);
  return response.data;
};

// ==================== RISK ASSESSMENT ====================

export const getRiskAssessment = async (patientId) => {
  const response = await api.get(`/api/v1/patient-workflows/patient/${patientId}/risk-assessment`);
  return response.data;
};

export const getNoShowPrediction = async (patientId) => {
  const response = await api.get(`/api/v1/patient-workflows/patient/${patientId}/no-show-prediction`);
  return response.data;
};

// ==================== NOTIFICATIONS ====================

export const getPatientNotifications = async (patientId, status = null) => {
  const params = status ? `?status=${status}` : '';
  const response = await api.get(`/api/v1/patient-workflows/patient/${patientId}/notifications${params}`);
  return response.data;
};

export const createNotification = async (patientId, notificationData) => {
  const response = await api.post(`/api/v1/patient-workflows/patient/${patientId}/notifications`, notificationData);
  return response.data;
};

export const markNotificationRead = async (patientId, notificationId) => {
  const response = await api.put(`/api/v1/patient-workflows/patient/${patientId}/notifications/${notificationId}/read`);
  return response.data;
};

// ==================== AI AGENT ====================

export const chatWithAI = async (patientId, message, conversationId = null) => {
  const response = await api.post(`/api/v1/patient-ai/patient/${patientId}/chat`, {
    message,
    conversation_id: conversationId
  });
  return response.data;
};

export const getConversations = async (patientId, role = null) => {
  const params = {};
  if (role) params.role = role;
  const response = await api.get(`/api/v1/patient-ai/patient/${patientId}/conversations`, { params });
  return response.data;
};

export const getConversation = async (patientId, conversationId) => {
  const response = await api.get(`/api/v1/patient-ai/patient/${patientId}/conversation/${conversationId}`);
  return response.data;
};

export const deleteConversation = async (patientId, conversationId) => {
  const response = await api.delete(`/api/v1/patient-ai/patient/${patientId}/conversation/${conversationId}`);
  return response.data;
};

export const getQuickInsights = async (patientId) => {
  const response = await api.get(`/api/v1/patient-ai/patient/${patientId}/quick-insights`);
  return response.data;
};

// ==================== CONTEXT-AWARE CHAT ====================

export const contextChat = async (patientId, message, role = 'patient', conversationId = null) => {
  const response = await api.post(`/api/v1/patient-ai/patient/${patientId}/context-chat`, {
    message,
    conversationId,
    role
  });
  return response.data;
};

export const getContextSummary = async (patientId, role = 'patient') => {
  const response = await api.get(`/api/v1/patient-ai/patient/${patientId}/context-summary`, {
    params: { role }
  });
  return response.data;
};

// ==================== HEALTH CHECK ====================

export const checkWorkflowHealth = async () => {
  const response = await api.get(`/api/v1/patient-workflows/health`);
  return response.data;
};

export const checkAIAgentHealth = async () => {
  const response = await api.get(`/api/v1/patient-ai/health`);
  return response.data;
};

export default {
  getFollowUpReminders,
  createFollowUpReminder,
  getMedicationReminders,
  logMedicationAdherence,
  getCareAlerts,
  getRiskAssessment,
  getNoShowPrediction,
  getPatientNotifications,
  createNotification,
  markNotificationRead,
  chatWithAI,
  getConversations,
  getConversation,
  deleteConversation,
  getQuickInsights,
  checkWorkflowHealth,
  checkAIAgentHealth
};
